import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import LandingOverlay from '@/pages/home/components/LandingOverlay';
import GoldParticles from './GoldParticles';
import GoldFrame from './GoldFrame';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col relative">
      <GoldParticles />
      <GoldFrame />
      <LandingOverlay />
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 pt-16 md:pt-20 relative z-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}